module.exports = __webpack_public_path__ + "static/media/5_5.40eeaf0d.jpg";